import { useState, useEffect } from 'react';
import { get } from 'lodash';

const useOrderNotification34 = (firebase, orderId) => {
    const [wasUnlocked, setWasUnlocked] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!firebase || !orderId) return;

        const fetchNotification = async () => {
            setLoading(true);
            try {
                const orderLogsRef = firebase
                    .collection('order-logs')
                    .doc(orderId);

                const orderLogsDoc = await orderLogsRef.get();

                if (!orderLogsDoc.exists) {
                    console.warn('[useOrderNotification34] El documento order-logs no existe para:', orderId);
                    setWasUnlocked(false);
                    return;
                }

                const notificationsSnapshot = await orderLogsRef.collection('notifications').get();
                const allNotifications = notificationsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                const hasNotification34 = allNotifications.some(n => n.notificationType === 34);
                setWasUnlocked(hasNotification34);
            } catch (error) {
                console.error('Error consultando notificaciones:', error);
                setWasUnlocked(false);
            } finally {
                setLoading(false);
            }
        };

        fetchNotification();
    }, [orderId]);

    return { wasUnlocked, loading };
};

export default useOrderNotification34;
